import { render, staticRenderFns } from "./DayDeliveryListComponent.vue?vue&type=template&id=4e056cae&"
import script from "./DayDeliveryListComponent.vue?vue&type=script&lang=js&"
export * from "./DayDeliveryListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports